// Sem patria globalne konstanty

export const SYSTEM_NAME_AUTH = 'AUTH';
export const SYSTEM_NAME_EPC = 'EPC';
export const SYSTEM_NAME_ETD = 'ETD';
export const SYSTEM_NAME_ISBN = 'ISBN';
export const SYSTEM_NAME_ROOMBOOK = 'ROOMBOOK';
export const SYSTEM_NAME_ZP = 'ZP';
export const SYSTEM_NAME_UIK = 'UIK';
export const SYSTEM_NAME_HELPDESK = 'HELPDESK';
export const SYSTEM_NAME_TOOLS = 'TOOLS';
export const SYSTEM_NAME_LIBADMIN = 'LIBADMIN';
export const SYSTEM_NAME_WAREHOUSE = 'WAREHOUSE';
export const SYSTEM_NAME_ALFRED = 'ALFRED';
export const SYSTEM_NAME_ORIGINALITY = 'ORIGINALITY';
export const SYSTEM_NAME_HELIOS = 'HELIOS';

export const SYSTEM_FULL_NAME_ETD = 'thesisEvidence';
export const SYSTEM_FULL_NAME_ROOMBOOK = 'roombook';
export const SYSTEM_FULL_NAME_WAREHOUSE = 'warehouse';
export const SYSTEM_FULL_NAME_LIBADMIN = 'Libadmin';
export const SYSTEM_FULL_NAME_UIK = 'Copycentrum';

/*
 * USER ROLES
 *
 *
 *
 */
const USER_ROLES = {
  SUPERADMIN: 'SUPERADMIN',
  UK_ADMIN: 'UK_ADMIN',
  LIBADMIN: 'LIBADMIN'
} as const;

export const UserRoles = {
  All: [
    USER_ROLES.SUPERADMIN,
    USER_ROLES.UK_ADMIN,
    USER_ROLES.LIBADMIN
  ],
  Superadmin: USER_ROLES.SUPERADMIN,
  UkAdmin: USER_ROLES.UK_ADMIN,
  Libadmin: USER_ROLES.LIBADMIN
} as const;

export const skLocalizationCalendar = {
  firstDayOfWeek: 1,
  dayNames: ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
  dayNamesShort: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
  dayNamesMin: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
  monthNames: [
    'Január',
    'Február',
    'Marec',
    'Apríl',
    'Máj',
    'Jún',
    'Júl',
    'August',
    'September',
    'Október',
    'November',
    'December',
  ],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  today: 'dnes',
  clear: 'Zmazať',
};

export const COLORS = {
  blueLight: '#92a2a8',
  blue: '#57889c',
  teal: '#568a89',
  blueDark: '#4c4f53',
  green: '#356e35',
  greenDark: '#496949',
  greenLight: '#71843f',
  purple: '#6e587a',
  magenta: '#6e3671',
  pink: '#ac5287',
  pinkDark: '#a8829f',
  yellow: '#b09b5b',
  orange: '#c79121',
  red: '#a90329',
  redLight: '#a65858'
};

export const SYSTEMS = [
  {
    id: 10,
    title: 'all',
    color: 'bg-color-blueDark',
    txtColor: 'txt-color-blueDark',
    brdColor: '#4c4f53',
    name: 'ALL'
  },
  {
    id: 1,
    name: 'LOGIN',
    color: 'bg-color-magenta',
    txtColor: 'txt-color-magenta',
    brdColor: '#6e3671'
  }, {
    id: 2,
    name: 'EPC',
    color: 'bg-color-yellow',
    txtColor: 'txt-color-yellow',
    brdColor: '#b09b5b'
  }, {
    id: 3,
    name: 'ETD',
    color: 'bg-color-blue',
    txtColor: 'txt-color-blue',
    brdColor: '#57889c'
  }, {
    id: 4,
    name: 'ROOMBOOK',
    color: 'bg-color-blueLight',
    txtColor: 'txt-color-blueLight',
    brdColor: '#92a2a8'
  }, {
    id: 5,
    name: 'ZP',
    color: 'bg-color-teal',
    txtColor: 'txt-color-teal',
    brdColor: '#568a89'
  }, {
    id: 6,
    name: 'UIK',
    color: 'bg-color-redLight',
    txtColor: 'txt-color-redLight',
    brdColor: '#a65858'
  }, {
    id: 7,
    name: 'HELPDESK',
    color: 'bg-color-greenLight',
    txtColor: 'txt-color-greenLight',
    brdColor: '#71843f'
  }, {
    id: 8,
    name: 'TOOLS',
    color: 'bg-color-purple',
    txtColor: 'txt-color-purple',
    brdColor: '#6e587a'
  }, {
    id: 9,
    name: 'ORIGINALITY',
    color: 'bg-color-orange',
    txtColor: 'txt-color-orange',
    brdColor: '#c79121'
  }
];

export const PRINT_ORDER_STATUSES = [
  {
    'id': 1,
    'title': 'CREATED'
  },
  {
    'id': 2,
    'title': 'FILE_UPLOADED'
  },
  {
    'id': 3,
    'title': 'TOKEN_RECEIVED'
  },
  {
    'id': 4,
    'title': 'PAYMENT_CREATED'
  },
  {
    'id': 5,
    'title': 'PAID'
  },
  {
    'id': 6,
    'title': 'CANCELED_BY_PAYER'
  },
  {
    'id': 7,
    'title': 'PAYMENT_REJECTED'
  },
  {
    'id': 8,
    'title': 'PAYMENT_REFUNDED'
  },
  {
    'id': 9,
    'title': 'SENT_TO_PKO'
  },
  {
    'id': 10,
    'title': 'PKO_EVALUATED'
  },
  {
    'id': 11,
    'title': 'PAID_BY_PROMO_CODE'
  },
  {
    'id': 12,
    'title': 'SENT_TO_PKO_FAILURE'
  },
  {
    'id': 13,
    'title': 'PKO_EVALUATION_FAILURE'
  }
];

